import PropTypes from 'prop-types';
import React, {
  useState,
  useEffect,
} from 'react';

import Comments from 'components/Comments';
// import tracker, { TrackerFragments } from 'lib/tracker';
import CommentInner from 'containers/cards/Comment/ReplyInner';
import apiGateway from '../../../lib/apiGateway';

const MediumComments = ({ medium }) => {
  const [loading, setLoading] = useState(true);
  const [edges, setEdges] = useState([]);
  const getFeedCommentsApi = () => {
    apiGateway.getFeedComments({
      eventId: medium.feedInfo.eventId === 0 ? medium.sponsor.id : medium.feedInfo.eventId,
      model: 'SocialAsset',
      modelId: medium.assetInfo.id,
      userId: medium.personInfo.id,
    }).then(res => {
      setEdges(res);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (medium) {
      getFeedCommentsApi();
    }
  }, [medium]);
  const refresh = () => {
    getFeedCommentsApi();
  };

  return (
    <Comments
      // hasMore={hasNextPage}
      loading={loading}
    // onLoadMore={onLoadMore}
    >
      {edges?.map((reply) => {
        return (
          <CommentInner
            onRefresh={() => refresh()}
            eventOrSponsorId={medium.assetInfo.id}
            modal='SocialAsset'
            comment={reply}
            key={reply.id}
          // onDelete={() => onDelete(reply)}
          // viewer={viewer}
          />
        );
      })}
    </Comments>
  );
};

MediumComments.propTypes = {
  medium: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default MediumComments;
